import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AlertService } from '../../services/alerts.service';
import { Alert } from '../../typings/alerts';
import { getAlerts } from '../../store/selectors';
import { State } from '../../typings/state';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cmx-alerts-output',
  templateUrl: './alerts-output.component.html',
  styleUrls: ['./alerts-output.component.scss'],
  animations: [
    trigger('alert', [
      transition('void => *', [
        style({ height: '0', opacity: 0 }),
        animate('.3s ease-in-out', style({ height: '*', opacity: 1 })),
      ]),
      transition('* => void', [
        style({ height: '*', opacity: 1 }),
        animate('.3s ease-in', style({ height: '0', opacity: 0 })),
      ]),
    ]),
  ],
})
export class AlertsOutputComponent implements OnInit, OnDestroy {
  text: string;
  clickableText: string;

  private alertsSub: Subscription;

  @Input()
  name: string;
  alerts: Alert[];

  @Input()
  modifyZIndex = false;

  constructor(
    private store: Store<State>,
    private alertsService: AlertService,
  ) {}

  ngOnInit() {
    this.alertsSub = this.store.pipe(select(getAlerts)).subscribe((alerts) => {
      alerts[this.name] ? (this.alerts = alerts[this.name]) : (this.alerts = []);
      for (const alert of this.alerts.slice(0, 4)) {
        this.text = alert.text.split('-')[0];
        this.clickableText = alert.text.split('-')[1];
      }
    });
  }

  onCloseClick(id: number) {
    this.alertsService.closeAlert(id, this.name);
  }

  mouseEnter(id: number) {
    this.alertsService.setHover(id);
  }

  mouseLeave() {
    this.alertsService.unsetHover();
  }

  ngOnDestroy() {
    this.alertsSub && this.alertsSub.unsubscribe();
  }
}
